import { Link } from "react-router-dom";
import { ArrowUpRight, GlassWater, Sun, CheckCircle2 } from "lucide-react";
import { FadeUp, MaskedLines } from "@/components/Reveal";

const STEPS = [
  {
    num: "01",
    icon: Sun,
    title: "Start with breakfast",
    copy: "Vibe's intended routine is in the morning — have one sachet with or after breakfast.",
  },
  {
    num: "02",
    icon: GlassWater,
    title: "Prepare your sachet",
    copy: "Open the sachet and just pour into room-temperature water and mix well.",
  },
  {
    num: "03",
    icon: CheckCircle2,
    title: "Keep it considered",
    copy: "Follow the labeled directions for use, every single morning.",
  },
];

export default function Routine() {
  return (
    <div data-testid="page-routine">
      <section className="mx-auto max-w-[88rem] px-5 sm:px-10 pt-[8.5rem] lg:pt-[10.5rem] pb-24 lg:pb-36">
        <div className="text-center max-w-3xl mx-auto">
          <FadeUp>
            <p className="text-xs uppercase tracking-[0.26em] text-[#4A6B56] mb-7">
              Make room for your morning
            </p>
          </FadeUp>
          <h1 className="font-display text-[clamp(2.7rem,5.5vw,5rem)] leading-[1.03] text-[#1B4332]">
            <MaskedLines onView lines={["Your routine. Made simple."]} />
          </h1>
        </div>

        <div className="mt-20 lg:mt-24 grid md:grid-cols-3 gap-14 lg:gap-10">
          {STEPS.map((step, i) => (
            <FadeUp key={step.num} delay={i * 0.12} className="relative">
              <span
                aria-hidden="true"
                className="absolute -top-6 right-0 font-display text-[5.5rem] leading-none text-[#1B4332]/10 select-none"
              >
                {step.num}
              </span>
              <span className="block text-[#1B4332]">
                <step.icon size={30} strokeWidth={1.5} />
              </span>
              <h2 className="mt-8 font-display text-2xl sm:text-3xl text-[#1B4332]">{step.title}</h2>
              <p className="mt-4 text-[#4A6B56] leading-relaxed max-w-sm">{step.copy}</p>
            </FadeUp>
          ))}
        </div>

        <FadeUp className="mt-20 lg:mt-24">
          <div className="rounded-2xl bg-[#F1F8F2] border border-[#D1E2D6]/60 p-10 sm:p-14 flex flex-col lg:flex-row items-start lg:items-center justify-between gap-10">
            <div>
              <h2 className="font-display text-[clamp(1.7rem,2.8vw,2.4rem)] leading-[1.15] text-[#1B4332] max-w-xl">
                Start your morning ritual.
              </h2>
              <p className="mt-3 max-w-md text-[#4A6B56] leading-relaxed">
                Your sachets are one click away — free shipping across India.
              </p>
            </div>
            <Link
              to="/shop"
              data-testid="routine-order-button"
              className="animate-cta-glow group inline-flex items-center gap-2.5 rounded-full bg-[#1B4332] text-[#E8F3EB] pl-8 pr-6 h-13 min-h-[3.25rem] text-lg font-semibold hover:bg-[#2D5A44] hover:scale-[1.02] transition-all duration-300 shrink-0"
            >
              Order now
              <ArrowUpRight
                size={19}
                className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </Link>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
